import { doc, getDoc, updateDoc, onSnapshot, setDoc, type Unsubscribe } from 'firebase/firestore';
import { db } from '../lib/firebase/app';
import type { AppConfig } from '../types';

const CONFIG_DOC = doc(db, 'appConfig', 'main');

export async function getAppConfig(): Promise<AppConfig | null> {
  const snap = await getDoc(CONFIG_DOC);
  return snap.exists() ? (snap.data() as AppConfig) : null;
}

export function subscribeAppConfig(onUpdate: (cfg: AppConfig) => void): Unsubscribe {
  return onSnapshot(CONFIG_DOC, snap => {
    if (snap.exists()) onUpdate(snap.data() as AppConfig);
  });
}

export async function updateAppConfig(data: Partial<AppConfig>): Promise<void> {
  await updateDoc(CONFIG_DOC, data);
}

export async function setAppConfigField(fieldPath: string, value: unknown): Promise<void> {
  await updateDoc(CONFIG_DOC, { [fieldPath]: value });
}
